import { Button, rem } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Fragment } from "react";

import { type ISection } from "../../../../../interfaces";
import Section from "../../../EntriesGenerator/Section/Section/Section";

interface Props {
  section: ISection;
  onNavigateBack?: () => void;
}

const HistoryModalSection = ({ section, onNavigateBack }: Props) => (
  <Fragment>
    {onNavigateBack && (
      <Button
        leftIcon={<IconArrowLeft />}
        variant="outline"
        onClick={onNavigateBack}>
        Go back
      </Button>
    )}
    <div
      style={{
        overflowX: "auto",
        width: "100%",
        marginTop: rem(10),
      }}>
      <Section section={section} sIndex={0} applyHistory />
    </div>
  </Fragment>
);
export default HistoryModalSection;
